import { autoUpdate, computePosition, flip, shift } from '@floating-ui/dom';

const FormCheckboxDropdownHook = {
  mounted() {
    this.cleanup;
    this.open = false;

    this.toggleEl = this.el.querySelector('[data-el=toggle]');
    this.contentEl = this.el.querySelector('[data-el=content]');

    this.el.addEventListener('show', () => {
      this.open = !this.open;
      this.update();
    });

    this.el.addEventListener('hide', () => {
      this.open = false;
      this.update();
    });

    this.updatePosition();
    this.updateState();
  },

  updated() {
    this.update();
  },

  updateState() {
    this.el.setAttribute('data-js-state', this.open ? 'open' : 'closed');
  },

  update() {
    this.updateState();

    if (this.open) {
      requestAnimationFrame(() => {
        this.cleanup = autoUpdate(this.toggleEl, this.contentEl, this.updatePosition.bind(this));
      });
    } else {
      if (this.cleanup) {
        this.cleanup();
      }
    }
  },

  updatePosition() {
    computePosition(this.el, this.contentEl, {
      placement: 'bottom-start',
      middleware: [flip(), shift()],
      strategy: 'fixed',
    }).then(({ x, y }) => {
      Object.assign(this.contentEl.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  },
};

export default FormCheckboxDropdownHook;
